"use client";
import * as React from "react";
const SvgGasStationOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M13.38 3.76 10.23.43l-.9.95 1.8 1.87a2.2 2.2 0 0 0-1.37 2.07c0 1.23.95 2.23 2.12 2.23q.45-.01.85-.2v6.42c0 .49-.39.89-.85.89s-.85-.4-.85-.9v-4c0-.97-.76-1.77-1.7-1.77H8.5V1.78A1.77 1.77 0 0 0 6.78 0h-5.1C.77 0 0 .8 0 1.78V16h8.49V9.33h1.27v4.45c0 1.22.95 2.22 2.12 2.22S14 15 14 13.78V5.33c0-.61-.24-1.17-.62-1.57m-6.6 10.46H1.7V8h5.09zm0-8H1.7V1.78h5.09zm5.1 0c-.47 0-.85-.4-.85-.89s.38-.89.85-.89.85.4.85.9c0 .48-.38.88-.85.88" }));
export {
  SvgGasStationOutlined as default
};
